import { Modal } from 'antd';
import { Box } from '@mui/material';
import { useState, useRef } from 'react';
import PageHeader from '../components/common/PageHeader';
import HistoryList from '../components/history/HistoryList';
import HistoryForm from '../components/history/HistoryForm';
import { HistoryOutlined as HistoryIcon } from '@mui/icons-material';

const History = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const listRef = useRef();

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalVisible(true);
  };

  const handleSuccess = () => {
    setIsModalVisible(false);
    setSelectedItem(null);
    listRef.current?.refresh();
  };

  return (
    <Box className="premium-container">
      <PageHeader
        title="History Management"
        subtitle="Review and manage the chronological records and historical data of the organization."
        titleIcon={<HistoryIcon />}
        btnText="ADD ITEM"
        onBtnClick={() => {
          setSelectedItem(null);
          setIsModalVisible(true);
        }}
      />

      <Box className="premium-table-card">
        <HistoryList
          ref={listRef}
          onEdit={handleEdit}
        />
      </Box>

      <Modal
        title={selectedItem ? 'Edit History Item' : 'Add History Item'}
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setSelectedItem(null);
        }}
        footer={null}
        width={800}
      >
        <HistoryForm
          initialValues={selectedItem}
          onSuccess={handleSuccess}
          onCancel={() => {
            setIsModalVisible(false);
            setSelectedItem(null);
          }}
        />
      </Modal>
    </Box>
  );
};

export default History;